import { components } from "@/api-schema";
import { ImplementedAccessorColumnDef } from "@/components/data-table/types";
import i18next from "i18next";
import { Check } from "lucide-react";
import { commonColumns } from "./_constants/common-columns";

export type CasaviContactWhitelistTableType = components["schemas"]["CasaviContactWhitelist"];

export const casaviContactWhitelistTableDefaultColumns = {
  columnElement: {
    id: "element",
    size: 150,
    enableSorting: true,
    header: () => i18next.t("casavi:Element"),
    accessorFn: (row: CasaviContactWhitelistTableType) => row.element,
    cell: (row) => {
      const value = row.getValue() as string;
      const map: Record<string, string> = {
        id: i18next.t("casavi:ElementId"),
        email: i18next.t("casavi:ElementEmail"),
        firstName: i18next.t("common:FirstName"),
        lastName: i18next.t("common:LastName"),
        companyName: i18next.t("casavi:ElementCompanyName"),
      };
      return map[value] || value;
    },
  } as ImplementedAccessorColumnDef<CasaviContactWhitelistTableType, string>,
  columnType: {
    id: "type",
    size: 120,
    enableSorting: true,
    header: () => i18next.t("casavi:Type"),
    accessorFn: (row: CasaviContactWhitelistTableType) => row.type,
    cell: (row) => {
      const value = row.getValue() as string;
      const map: Record<string, string> = {
        regex: i18next.t("casavi:TypeRegex"),
        contains: i18next.t("casavi:TypeContains"),
        full: i18next.t("casavi:TypeFull"),
      };
      return map[value] || value;
    },
  } as ImplementedAccessorColumnDef<CasaviContactWhitelistTableType, string>,
  columnValue: {
    id: "value",
    size: 200,
    enableSorting: true,
    header: () => i18next.t("casavi:Value"),
    accessorFn: (row: CasaviContactWhitelistTableType) => row.value,
    cell: (row) => row.getValue(),
  } as ImplementedAccessorColumnDef<CasaviContactWhitelistTableType, string>,
  columnCaseSensitive: {
    id: "caseSensitive",
    size: 120,
    enableSorting: true,
    header: () => i18next.t("casavi:CaseSensitiveColumn"),
    accessorFn: (row: CasaviContactWhitelistTableType) => row.caseSensitive,
    cell: (row) => {
      const value = row.getValue();
      return value ? <Check className="h-4 w-4" /> : null;
    },
  } as ImplementedAccessorColumnDef<CasaviContactWhitelistTableType, boolean>,
  columnUuid: commonColumns.columnUuid<CasaviContactWhitelistTableType>(),
  columnCreatedAt: commonColumns.columnCreatedAt<CasaviContactWhitelistTableType>(),
  columnUpdatedAt: commonColumns.columnUpdatedAt<CasaviContactWhitelistTableType>(),
};
